(function () {
  function getMainImage(swatchLi) {
    const card = swatchLi.closest('.product-card');
    return card ? card.querySelector('.product-card__image--main img') : null;
  }

  document.addEventListener(
    'mouseenter',
    function (event) {
      const li = event.target.closest && event.target.closest('.swatches--product-card > li[data-hover-image]');
      if (!li) return;

      const img = getMainImage(li);
      if (!img) return;

      const hoverSrc = li.dataset.hoverImage;
      if (!hoverSrc) return;

      if (!img.dataset.originalSrc) {
        img.dataset.originalSrc = img.currentSrc || img.src;
      }
      if (!img.dataset.originalSrcset) {
        img.dataset.originalSrcset = img.srcset || '';
      }

      img.srcset = '';
      img.src = hoverSrc;
    },
    true
  );

  document.addEventListener(
    'mouseleave',
    function (event) {
      const li = event.target.closest && event.target.closest('.swatches--product-card > li[data-hover-image]');
      if (!li) return;

      const img = getMainImage(li);
      if (!img) return;

      if (img.dataset.originalSrc) {
        img.src = img.dataset.originalSrc;
      }
      if (img.dataset.originalSrcset !== undefined) {
        img.srcset = img.dataset.originalSrcset;
      }
    },
    true
  );
})();